import * as Ably from 'ably';

// Add a mock auth token callback to prevent Ably warnings
export const mockFetchAuthToken = (tokenParams, callback) => {
  // In a real implementation, this would call an API to get a new token
  // For now, just use the existing token if we have one
  if (tokenParams) {
    callback(null, tokenParams);
  } else {
    return;
  }
};

/**
 * Create a custom Ably client with enhanced channels that apply default publish options
 */
export const createEnhancedAblyClient = clientOptions => {
  try {
    // Create a clone of the client options to avoid modifying the original

    const options = Object.assign({}, clientOptions);
    const client = new Ably.Realtime(options);
    const originalGet = client.channels.get;
    client.channels.get = function (channelName, channelOptions) {
      const channel = originalGet.call(this, channelName, channelOptions);
      const originalPublish = channel.publish;
      channel.publish = function (name, data, callback) {
        const enhancedData = Object.assign({}, data);
        return originalPublish.call(this, name, enhancedData, callback);
      };
      return channel;
    };
    return client;
  } catch (error) {
    console.error('Error creating Ably client:', error);
    throw error;
  }
};